import { Box, Stack, Typography } from "@mui/material";

interface TabBarProps {
  tabs: string[];
  activeIndex: number;
  onChange: (index: number) => void;
}

export default function TabBar({ tabs, activeIndex, onChange }: TabBarProps) {
  return (
    <Stack direction="row" sx={{ mb: 3, width: "100%" }}>
      {tabs.map((tab, index) => (
        <Box
          key={index}
          onClick={() => onChange(index)}
          sx={{
            flex: 1,
            textAlign: "center",
            py: 1.5,
            cursor: "pointer",
            borderBottom:
              index === activeIndex
                ? "3px solid #724e41"
                : "3px solid transparent",
            "&:hover": {
              bgcolor: "rgba(114,78,65,0.05)",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: index === activeIndex ? 700 : 400,
              fontSize: "16px",
              color: index === activeIndex ? "#724e41" : "#000000",
            }}
          >
            {tab}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
